// This file is auto-generated by @hey-api/openapi-ts

import type { RequestResult } from '../client';
import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { CreateOrderUsingPostData, CreateOrderUsingPostErrors, CreateOrderUsingPostResponses, OrderStateUsingGetData, OrderStateUsingGetErrors, OrderStateUsingGetResponses, ResendRegisterCodeUsingPostData, ResendRegisterCodeUsingPostErrors, ResendRegisterCodeUsingPostResponses } from '../types.gen';

export class DesktopOrderControllerService {
    /**
     * createOrder
     */
    public static createOrderUsingPost<ThrowOnError extends boolean = false>(options?: Options<CreateOrderUsingPostData, ThrowOnError>): RequestResult<CreateOrderUsingPostResponses, CreateOrderUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<CreateOrderUsingPostResponses, CreateOrderUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/order/create',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * resendRegisterCode
     */
    public static resendRegisterCodeUsingPost<ThrowOnError extends boolean = false>(options?: Options<ResendRegisterCodeUsingPostData, ThrowOnError>): RequestResult<ResendRegisterCodeUsingPostResponses, ResendRegisterCodeUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<ResendRegisterCodeUsingPostResponses, ResendRegisterCodeUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/order/resend/code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * orderState
     */
    public static orderStateUsingGet<ThrowOnError extends boolean = false>(options?: Options<OrderStateUsingGetData, ThrowOnError>): RequestResult<OrderStateUsingGetResponses, OrderStateUsingGetErrors, ThrowOnError> {
        return (options?.client ?? client).get<OrderStateUsingGetResponses, OrderStateUsingGetErrors, ThrowOnError>({ url: '/v1/desktop/order/state', ...options });
    }
}
